import { AlertStatus } from "@/models/alert-status";
import { AlertType } from "@/models/alert-type";
import { ToiletType } from "@/models/toilet-type";

export class Alert {
    alertType?: string;
    status?: string;
    floor?: string;
    kind?: string;
    areaName?: string;
    name?: string;
    time?: string;
    floorPlanUrl?: string;

    constructor(params?: Partial<Alert>) {
        Object.assign(this, params);
    }
}
